import { AxiosError } from "axios";

export const getErrorMessage = (error: unknown, fallback?: string) => {
  if (error instanceof AxiosError) {
    if (error.response?.data?.error?.message) {
      let ret = error.response.data?.error?.message;
      if (error.response.data?.error?.details)
        ret += `: ${error.response.data.error.details}`;
      return ret;
    }
    const errors = error.response?.data?.error?.errors;
    if (Array.isArray(errors))
      return errors.reduce(
        (acc: any, err: any, idx: number) =>
          acc + `${idx !== 0 ? ", " : ""}${err}`,
        ""
      );
    // Handle errors as object with array values (e.g., {enrollment: ["message"]})
    if (errors && typeof errors === "object")
      return Object.values(errors).flat().join(", ");
    // Handle direct message format (common for 422 and other validation errors)
    if (error.response?.data?.message) return error.response.data.message;
  }

  if (error instanceof Error) return error.message;

  return fallback || "Something went wrong, please try again later";
};
